import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { fetchAllPages } from './config/Pagination'


export const getFaqs = async (unitId:string) =>
  fetchAllPages<any>(`${Config.core.faqs}`, {
    sort: 'idFaq',
    ...(unitId ? { 'unitId.equals': unitId } : {}),
  })

